export default __webpack_public_path__ + "static/media/arrow-down.5e2dfb43.svg";